import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslationService } from 'src/app/services/translation.service';
import { Chart, CategoryScale, LinearScale, Title, Tooltip, Legend, LineController, LineElement, PointElement } from 'chart.js';
import { ReportsService } from 'src/app/services/reports.service';
import { ExamFolderService } from 'src/app/services/exam-folder.service';
import { ExamService } from 'src/app/services/exam.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { PDFDocument} from 'pdf-lib';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import fontkit from '@pdf-lib/fontkit';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule],
})
export class ReportsComponent {
  
  constructor(public translationService: TranslationService, private reportService: ReportsService, private examFolders: ExamFolderService, private examService: ExamService) {
    Chart.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, Title, Tooltip, Legend);
  }

  selectedWidget: any = null;
  candidateResultsWidget: any[] = [];
  testDetailsWidget: any[] = [];
  examViolationsWidget: any[] = [];
  performanceWidget: any[] = [];

  fromDate: string = (() => {
    const d = new Date(2025, 0, 1);
    d.setHours(12, 0, 0, 0);
    return d.toISOString().substring(0, 10);
  })();


  toDate: Date = (() => {
    const d = new Date();
    d.setMonth(d.getMonth() + 12); 
    d.setHours(23, 59, 59, 999);
    return d;
  })();


  IDNumber: any = null;
  examAttendNumber: any = null;

  selectedCourseFilter: string = '';
  selectedLangFilter: string = '';
  selectedGenderFilter: string = '';
  selectedBookingTypeFilter: string = '';

  uniqueCourses: any[] = [];
  uniqueLanguages: any[] = [];
  uniqueGenders: any[] = [];
  uniqueBookingTypes: any[] = [];

  TraineeName: string = '';
  CourseName: string = '';
  LanguageName: string = '';
  Marks: number = 0;
  ExamResult: string = '';

  candidateDistributionPerYear: any = [];

  ngOnInit() {}

  ngAfterViewInit() {
    this.CandidateDistribution()
  }

  widgets: { title: string; icon: string; data: any[] }[] = [
    { title: 'Candidate Results', icon: 'bi bi-people text-primary', data: [] },
    { title: 'Test Details', icon: 'bi bi-file-earmark-text text-warning', data: [] },
    { title: 'Performance', icon: 'bi bi-graph-up text-success', data: [] },
  ];


  selectWidget(widget: any) {
    this.selectedWidget = widget;
    switch (widget.title) {
      case 'Candidate Results':
        this.CandidateResults();
        break;
    }
  }

  closeModal() {
    this.IDNumber = null;
    this.examAttendNumber = null;
    this.selectedWidget = null;
    this.candidateResultsWidget = [];
    this.testDetailsWidget = [];
    this.examViolationsWidget = [];
    this.performanceWidget = [];
    this.uniqueCourses = [];
    this.uniqueLanguages = [];
    this.uniqueGenders = [];
    this.uniqueBookingTypes = [];
    this.TraineeName = '';
    this.CourseName = '';
    this.LanguageName = '';
    this.Marks = 0;
    this.ExamResult = '';
    this.selectedCourseFilter = '';
    this.fromDate = (() => {
      const d = new Date(2025, 0, 1);
      d.setHours(12, 0, 0, 0);
      return d.toISOString().substring(0, 10);
    })();
    this.toDate = (() => {
      const d = new Date();
      d.setMonth(d.getMonth() + 12); 
      d.setHours(23, 59, 59, 999);
      return d;
    })();
  }

  CandidateResults() {
    this.reportService.getCandidateResults().subscribe(
      (response: any) => {
          this.candidateResultsWidget = response.result[0];
          this.widgets[0].data = this.candidateResultsWidget;
          this.uniqueCourses = [...new Set(this.selectedWidget.data.map((x: any) =>  x.CourseName))];
          this.uniqueLanguages = [...new Set(this.selectedWidget.data.map((x: any) =>  x.courseLang))];
          this.uniqueGenders = [...new Set(this.selectedWidget.data.map((x: any) => x.Gender))];
          this.uniqueBookingTypes = [...new Set(this.selectedWidget.data.map((x: any) => x.BookingType))];
      },
    );
  }

  get filteredCandidateResults() {
    return this.candidateResultsWidget.filter(student => {
      const idMatch = this.IDNumber ? student.IDNumber?.toString().includes(this.IDNumber) : true;
      const courseMatch = this.selectedCourseFilter ? student.CourseName === this.selectedCourseFilter : true;
      const langMatch = this.selectedLangFilter ? student.courseLang === this.selectedLangFilter : true;
      const genderMatch = this.selectedGenderFilter ? student.Gender === this.selectedGenderFilter : true;
      const bookingTypeMatch = this.selectedBookingTypeFilter ? student.BookingType === this.selectedBookingTypeFilter : true;

      const startDate = this.fromDate ? new Date(this.fromDate) : null;
      const endDate = this.toDate ? new Date(this.toDate) : null;
      const examEndDate = student.EndExamTime ? new Date(student.EndExamTime) : null;

      const dateMatch = examEndDate &&
        (!startDate || examEndDate >= startDate) &&
        (!endDate || examEndDate <= endDate);

      return idMatch && courseMatch && langMatch && genderMatch && bookingTypeMatch && dateMatch;
    });
  }

  searchTestDetails() {
    this.reportService.getTestDetails(this.examAttendNumber).subscribe(
      (response: any) => {
        this.testDetailsWidget = response.result[0];
        this.widgets[1].data = this.testDetailsWidget;

        this.TraineeName = this.testDetailsWidget[0]?.TraineeName || '';
        this.IDNumber = this.testDetailsWidget[0]?.IDNumber || null;
        this.CourseName = this.testDetailsWidget[0]?.CourseName || '';
        this.LanguageName = this.testDetailsWidget[0]?.LanguageName || '';

        this.reportService.getCandidateResults(this.examAttendNumber).subscribe(
          (resultsResponse: any) => {
            this.selectedGenderFilter = resultsResponse.result[0][0].Gender;
            this.selectedBookingTypeFilter = resultsResponse.result[0][0].BookingType;
            this.Marks = resultsResponse.result[0][0].Marks || 0;
            this.ExamResult = resultsResponse.result[0][0].ExamResult || '';
          }
        );
      },
    );
  }

  getExamViolations(){
    this.reportService.getExamViolations().subscribe(
      (response: any) => {
        this.examViolationsWidget = response.result[0];
        this.widgets[2].data = this.examViolationsWidget;
      },
    );
  }
  
  get filteredexamViolationsWidget() {
    return this.examViolationsWidget.filter(student => {  
      const idMatch = this.IDNumber ? student.IDNumber?.toString().includes(this.IDNumber) : true;
      const courseMatch = this.selectedCourseFilter ? student.CourseName === this.selectedCourseFilter : true;
      const langMatch = this.selectedLangFilter ? student.LanguageName === this.selectedLangFilter : true;
      const genderMatch = this.selectedGenderFilter ? student.Gender === this.selectedGenderFilter : true;
      const bookingTypeMatch = this.selectedBookingTypeFilter ? student.BookingType === this.selectedBookingTypeFilter : true;

      const startDate = this.fromDate ? new Date(this.fromDate) : null;
      const endDate = this.toDate ? new Date(this.toDate) : null;
      const examEndDate = student.CreateDate ? new Date(student.CreateDate) : null;
      const dateMatch = examEndDate &&
        (!startDate || examEndDate >= startDate) &&
        (!endDate || examEndDate <= endDate);

      this.examViolationsWidget = this.selectedWidget.data

      return idMatch && courseMatch && langMatch && genderMatch && bookingTypeMatch && dateMatch;
    });
  }

  async viewReport(report: any) {
    
    // const [pdfBytes, fontBytes] = await Promise.all([
    //   firstValueFrom(this.http.get('assets/attachments/Reported_Candidate.pdf', { responseType: 'arraybuffer' })),
    //   firstValueFrom(this.http.get('assets/fonts/Cairo-Bold.ttf', { responseType: 'arraybuffer' }))
    // ]);

    // const pdfDoc = await PDFDocument.load(pdfBytes);
    // pdfDoc.registerFontkit(fontkit);

    // const arabicFont = await pdfDoc.embedFont(fontBytes, { subset: true });

    // const form = pdfDoc.getForm();

    // const courseName = report.CourseName?.trim();

    // switch (courseName) {
    //   case 'Food Safety':
    //     form.getCheckBox('fs_checkbox').check();
    //     break;
    //   case 'Barbershops':
    //     form.getCheckBox('br_checkbox').check();
    //     break;
    //   case 'Laundry':
    //     form.getCheckBox('la_checkbox').check();
    //     break;
    //   case 'Beauty Salons':
    //     form.getCheckBox('bs_checkbox').check();
    //     break;
    //   default:
    //     console.warn(`❗ CourseName "${courseName}" not recognized`);
    //     break;
    // }

  
    // Object.entries(data).forEach(([key, value]) => {
    //   try {
    //     const field = form.getTextField(key);
    //     field.setText(String(value));
    //     field.updateAppearances(arabicFont); 
    //   } catch {
    //     console.warn(`❗ Field ${key} not found in PDF`);
    //   }
    // });

    // const filledPdf = await pdfDoc.save();
    // const blob = new Blob([filledPdf], { type: 'application/pdf' });
    // saveAs(blob, `Violation_Report_${report.IDNumber || 'unknown'}.pdf`);
  }

// Done
  CandidateDistribution(){
    this.reportService.getCandidateDistribution(null).subscribe(result => {
      this.candidateDistributionPerYear = result.result[0];
      const monthData = this.candidateDistributionPerYear.map((item: any) => {
        return item.ExamCount === 'N/A' ? null : item.ExamCount;
      });
      this.createChart('candidateDistributionChart', monthData);
    });
  }
  
  createChart(chartId: string, monthData: any) {
    const canvas = document.getElementById(chartId) as HTMLCanvasElement;
    const ctx = canvas?.getContext('2d');
  
    if (ctx) {
      const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
      gradient.addColorStop(0, 'rgba(160, 160, 160, 0.5)');
      gradient.addColorStop(1, 'rgba(160, 160, 160, 0)');
  
      new Chart(ctx, {
        type: 'line',
        data: {
          labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          datasets: [{
            label: this.translationService.getTranslation('Candidate Distribution'),
            data: monthData,
            borderColor: '#28a745',
            pointBackgroundColor: '#28a745',
            fill: true,
            borderWidth: 2,
            tension: 0.4
          }]
        },
        options: {
          plugins: {
            legend: { display: false },
          },
          scales: {
            y: {
              beginAtZero: true,
              suggestedMax: 120
            }
          }
        }
      });
    }
  }
  
  exportToExcel(): void {
    if (!this.selectedWidget || !this.selectedWidget.data || this.selectedWidget.data.length === 0) {
      console.error('No data available for export');
      return;
    }

    let data: any[] = [];
    switch (this.selectedWidget.title) {
      case 'Candidate Results':
        data = this.filteredCandidateResults;
        break;
        
      case 'Exam Violations':
        data = this.filteredexamViolationsWidget;
        break;
          
      default:
        data = this.selectedWidget.data;
        break;
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const headers = Object.keys(data[0]);

    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });
    worksheet['!cols'] = headers.map(() => ({ wch: 20 }));

    headers.forEach((header, idx) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: idx });
      if (!worksheet[cellAddress]) return;
      worksheet[cellAddress].s = {
        fill: { fgColor: { rgb: '28A745' } },
        font: { color: { rgb: 'FFFFFF' }, bold: true },
        alignment: { horizontal: 'center', vertical: 'center' }
      };
    });
    
    worksheet['!autofilter'] = { ref: `A1:${XLSX.utils.encode_col(headers.length - 1)}${data.length + 1}` };

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Exam Report': worksheet },
      SheetNames: ['Exam Report'],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
      cellStyles: true
    });

    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    
    if(this.selectedWidget.title == 'Test Details'){
      FileSaver.saveAs(blob, `${this.selectedWidget.data[0].IDNumber.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`);
      
    } else{
      FileSaver.saveAs(blob, `${this.selectedWidget.title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`);
    }
  }
}
